export enum HallowABFlag {
  WebAdventShortOnboarding = "web_advent_short_onboarding",
  WebFamilyPlanUpgradeAdvent = "web_family_plan_one_click_upgrade_advent",
  WebLifeStageQuestion = "web_life_stage_question",
  WebMediumOnboarding = "web_medium_onboarding",
  WebHomepageCTADestination = "web_homepage_cta_destination",
  WebVariableTrialLength = "web_variable_trial_length",
  WebSubscreenArrowButton = "web_subscreen_arrow_button",
  WebDOBCollection = "web_dob_collection",
  FamilyPlanOneClickUpgrade = "family_plan_upgrade",
}
